import { render, staticRenderFns } from "./CompensationZipSuccessAlerts.vue?vue&type=template&id=135e8698&scoped=true&"
import script from "./CompensationZipSuccessAlerts.vue?vue&type=script&lang=ts&"
export * from "./CompensationZipSuccessAlerts.vue?vue&type=script&lang=ts&"
import style0 from "./CompensationZipSuccessAlerts.vue?vue&type=style&index=0&id=135e8698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135e8698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VSlideYTransition})
